export var lazyOptions = {
    triggerOnce: true,
    rootMargin: '300px 0px',
};
export var placeholderSrc = function (_a) {
    var width = _a[0], height = _a[1];
    return "data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 ".concat(width, " ").concat(height, "\"%3E%3C/svg%3E");
};
//# sourceMappingURL=shared.js.map